<collection-form [formModel]="collectionForm"></collection-form>